import request from '@/utils/request'
import * as  auth  from '@/utils/auth'
let baseUrl = '/api/user/'
let authUrl = '/auth/competition/member'

export function login(data){
    return request({
        url: baseUrl+"login/password",
        method: 'post',
        data: data
    })
}

export function getMemberInfo(compId,stageId){
    return request({
        url: authUrl+"/get",
        method: 'get',
        params: {
            compId: compId,
            stageId: stageId
        }
    })
}

export function getPaper(compId,stageId){
    return request({
        url: authUrl+"/paper",
        method: 'get',
        params: {
            compId: compId,
            stageId: stageId
        }
    })
}

export function loginout(){
    let userInfo = auth.getInfo()    
    return request({
        url: baseUrl+"login/out",
        method: 'get',
        params: {
            userNo: userInfo.id
        }
    })
}

export function saveInfo(info){
    let url = "/auth/user/complete"
    return request({
        url: url,
        method: 'post',
        data: info
    })
}

export function updateInfo(){
    let url ="/auth/competition/member/updateInfo"
    return request({
        url: url,
        method: 'get'
    })
}


// WEBPACK FOOTER //
// ./src/api/member.js